import React, { useCallback, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import ReqHeader from "./global/components/ReqHeader";
import InputBox from "./global/components/InputBox";
import Dollar from "./assets/dollar.png";
import EditIcon from "./assets/editIcon.png";

import Button from "./global/components/Button";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  sendReportData,
  clearSendReportError,
} from "../../actions/addLinkedAccounts";
import FullCard from "./assets/fullCard.png";
import SmallCard from "./assets/insideCard.png";
import SideBar from "./global/components/SideBar";
import useWindowSize from "./global/hooks/WindowResizer";
import MobileViewHeader from "./global/components/MobileViewHeader";

const mapStateToProps = (state) => ({
  token: state.token,
  dashboardData: state.dashboardData,
});

const ReqProofFunds = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [token, setToken] = useState(null || props.token);
  const [sendReportStep, setSendReportStep] = useState(0);
  const [selectInfo, setSelectInfo] = useState({
    address: false,
    phone: false,
    accountNumber: false,
    transactions: false,
    report_type: 1,
    report_request_type: 1,
    message_body: null,
    message_subject: "",
    to_user_email: "",
    requestee_name: "",
    to_user_first_name: "",
    to_user_last_name: "",
    requester_name: "",
    agent_first_name: "",
    agent_last_name: "",
    proof_amount: 0,
    message_draft: 0,
    data: [],
  });
  const [selectedReportType, setSelectedReportType] = useState("");
  const [templateBorder, setTemplateBorder] = useState(false);
  const [stepZeroValid, setStepZeroValid] = useState(false);
  const [stepOneValid, setStepOneValid] = useState(false);
  const [error, setError] = useState(false);
  const [message, setMessage] = useState();
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [myAccountData, setMyAccountData] = useState(null);
  const [hasTriedToProceed, setHasTriedToProceed] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const isMobileView = useWindowSize();
  const {
    message_body,
    to_user_email,
    data,
    proof_amount,
    agent_first_name,
    agent_last_name,
    to_user_first_name,
    to_user_last_name,
    requestee_name,
    requester_name,
  } = selectInfo;

  const { reportSent, errorSendingReport, errorMsg } = useSelector(
    (state) => state
  );
  const [showErrorModal, setShowErrorModal] = useState(false);

  useEffect(() => {
    if (getEmailErrorMessage(selectInfo.to_user_email) === "") {
      setStepZeroValid(true);
    } else {
      setStepZeroValid(false);
    }
  }, [selectInfo.to_user_email]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_PAYVIEW_BASE_URL}/api/myaccount`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (res.status === 401) {
          history.push("/");
        }
      })
      .then((res) => res.json())
      .then(
        (result) => {
          setMyAccountData(result);
          console.log(result);
        },
        (error) => {
          setError(error);
        }
      );
  }, []);

  useEffect(() => {
    if (selectInfo.proof_amount > 0 && selectInfo.report_type) {
      setStepOneValid(true);
    } else {
      setStepOneValid(false);
    }
  }, [selectInfo.proof_amount, selectInfo.report_type]);

  useEffect(() => {
    if (errorSendingReport) {
      setShowLoadingModal(false);
      setShowErrorModal(true);
    }
  }, [errorSendingReport]);

  useEffect(() => {
    if (errorMsg) {
      console.log("setting message");
      setMessage(errorMsg);
    }
  }, [errorMsg]);

  //
  const handleUserFirstName = (event) => {
    setSelectInfo({
      ...selectInfo,
      agent_first_name: event.target.value.split(" ")[0],
    });
  };
  const handleUserLastName = (event) => {
    setSelectInfo({
      ...selectInfo,
      agent_last_name: event.target.value.split(" ")[0],
    });
  };
  const handleClientFirstName = (event) => {
    setSelectInfo({
      ...selectInfo,
      to_user_first_name: event.target.value.split(" ")[0],
    });
  };
  const handleClientLastName = (event) => {
    setSelectInfo({
      ...selectInfo,
      to_user_last_name: event.target.value.split(" ")[0],
    });
  };
  const handleEditBtn = () => {
    setShowPreview(false);
  };
  //

  const handleRequesteeEmail = (event) => {
    setSelectInfo({ ...selectInfo, to_user_email: event.target.value });
  };
  const handleRequesterName = (event) => {
    setSelectInfo({
      ...selectInfo,
      requester_name: event.target.value,
      agent_first_name: event.target.value.split(" ")[0],
      agent_last_name: event.target.value.split(" ")[1],
    });
  };
  const handleRequesteeName = (event) => {
    setSelectInfo({
      ...selectInfo,
      requestee_name: event.target.value,
      to_user_first_name: event.target.value.split(" ")[0],
      to_user_last_name: event.target.value.split(" ")[1],
    });
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(event);
    setSendReportStep((step) => step + 1);
    console.log(selectInfo);
  };
  const handleReportType = (event) => {
    setSelectedReportType(event.target.value);
    setTemplateBorder(event.target.value);
    setSelectInfo({
      ...selectInfo,
      report_type: parseInt(event.target.value, 10),
    });
    console.log(event.target.value);
    setError(false);
  };
  const handleAddress = (event) => {
    setSelectInfo({ ...selectInfo, [event.target.name]: event.target.checked });
  };
  const handlePhone = (event) => {
    setSelectInfo({ ...selectInfo, [event.target.name]: event.target.checked });
  };
  const handleAccountNumber = (event) => {
    setSelectInfo({ ...selectInfo, [event.target.name]: event.target.checked });
  };
  const handleTransactions = (event) => {
    // setSelectInfo({ ...selectInfo, [event.target.name]: event.target.checked });
  };
  const handleRequiredMin = (event) => {
    setSelectInfo({ ...selectInfo, proof_amount: event.target.value });
  };
  const amtFocus = () => {
    if (selectInfo.proof_amount === 0) {
      setSelectInfo({ ...selectInfo, proof_amount: "" });
    }
  };
  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };
  const formatNumbers = (num) => {
    if (num % 1 !== 0) {
      let localeNum = num.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return localeNum;
    } else {
      return num.toLocalString();
    }
  };
  const sendReportBack = () => {
    setSendReportStep((step) => step - 1);
  };
  const saveReportDraft = () => {
    setSelectInfo({ ...selectInfo, message_draft: 0 });
  };
  const sendReport = useCallback(() => {
    setHasTriedToProceed(true);
    setShowLoadingModal(true);
    console.log(selectInfo);
    dispatch(sendReportData(selectInfo));
  }, [dispatch, selectInfo]);
  const handleMessageBody = (event) => {
    setSelectInfo({ ...selectInfo, message_body: event.target.value });
  };
  const handleShowPreview = (event) => {
    setShowPreview(true);
  };

  const goToDashBoard = () => {
    return history.push("/dashboard");
  };
  const handleErrorModalClose = () => {
    setShowErrorModal(false);
    dispatch(clearSendReportError());
  };
  const getEmailErrorMessage = (email) => {
    if (email && !validateEmail(email)) {
      return "Enter a valid email address.";
    } else if (
      myAccountData &&
      myAccountData.accountInfo &&
      myAccountData.accountInfo.length > 0 &&
      myAccountData.accountInfo[0].email === email
    ) {
      return "Enter a different email from your account email.";
    }
    return "";
  };
  const emailText1 =
    // agent_first_name +
    // " " + agent_last_name + " has requested your proof of funds report.";
    " " + " has requested your proof of funds report.";

  const emailText2 =
    "Hello " + to_user_first_name + " " + to_user_last_name + ",";
  const emailText3 =
    "FastRealty has made it simple, safe, and secure for you to submit your proof of funds for the requested amount of $" +
    proof_amount +
    ".";

  const isAllDataFilled =
    proof_amount > 0 &&
    to_user_email.trim() !== "" &&
    agent_first_name.trim() !== "" &&
    agent_last_name.trim() !== "" &&
    to_user_first_name.trim() !== "" &&
    to_user_last_name.trim() !== "" &&
    validateEmail(to_user_email);

  return (
    <div className="req-root">
      {/* {!isMobileView && <SideBar />} */}
      <div className="reqProofFunds-root">
        {/* <ReqHeader /> */}
        {/* {!isMobileView && <ReqHeader />} */}
        {/* {isMobileView && <MobileViewHeader />} */}
        <div className="reqProofFunds-content">
          <h3 style={{ margin: 0 }}>Request Proof of Funds</h3>
          <p>
            Quickly and securely request the necessary documentation to verify
            your client's purchasing power.
          </p>
        </div>
        {!showPreview && (
          <div>
            <div className="reqProofFunds-form-container">
              <div className="users">
                <p>User's</p>
                <div className="users-input">
                  <InputBox
                    label="First Name"
                    placeholder="Enter you first name"
                    onChangeFunc={handleUserFirstName}
                    value={agent_first_name}
                  />
                  <InputBox
                    label="Last Name"
                    placeholder="Enter you last name"
                    onChangeFunc={handleUserLastName}
                    value={agent_last_name}
                  />
                </div>
              </div>
              <div className="line"></div>
              <div className="users" style={{ marginTop: 16 }}>
                <p>Client's</p>
                <div className="users-input">
                  <InputBox
                    label="First Name"
                    placeholder="Enter client's first name"
                    onChangeFunc={handleClientFirstName}
                    value={to_user_first_name}
                  />
                  <InputBox
                    label="Last Name"
                    placeholder="Enter client's last name"
                    onChangeFunc={handleClientLastName}
                    value={to_user_last_name}
                  />
                </div>
                <div className="users-input">
                  <InputBox
                    label="Email"
                    placeholder="Enter client's email address"
                    onChangeFunc={handleRequesteeEmail}
                    value={to_user_email}
                  />
                  <div className="user-input-box">
                    <label>Minimum required funds</label>
                    <input
                      type="number"
                      className="input-box-min-req-funds"
                      style={{ paddingLeft: 30 }}
                      onChange={handleRequiredMin}
                      value={proof_amount}
                    />
                    <img src={Dollar} alt="dollar" className="dollar-img" />
                  </div>
                </div>
                <div
                  className="users-input"
                  style={{ gridTemplateColumns: "repeat(1, 1fr)" }}
                >
                  <div className="user-input-box">
                    <label>Message</label>
                    <textarea
                      placeholder="Enter your message"
                      className="input-box-ta"
                      onChange={handleMessageBody}
                      value={message_body || ""}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="buttons">
              <Button
                title="CANCEL"
                txtColor="#28A382"
                bgColor="white"
                onClickFunc={() => goToDashBoard()}
              />
              <Button
                title="PREVIEW REQUEST"
                txtColor="white"
                bgColor="#28A382"
                disabled={!isAllDataFilled}
                onClickFunc={() => handleShowPreview()}
                borderColor="1px solid #28A382"
              />
            </div>
          </div>
        )}
        {showPreview && (
          <>
            <div className="email-preview">
              <div className="email-card">
                <div className="preview-white-card-container">
                  <div className="small-card">
                    <img
                      src={SmallCard}
                      alt="small-card"
                      className="small-card-bg"
                    />
                  </div>
                  <div className="contents">
                    <p className="mini-card-text1">
                      {/* <span className="mini-card-name">{agent_first_name}</span> */}
                      <span className="mini-card-name">{`${agent_first_name} ${agent_last_name}`}</span>
                      {emailText1}
                    </p>

                    <p className="mini-card-text2">{emailText2}</p>

                    <p className="mini-card-text2">{emailText3}</p>
                    {/* <p className="mini-card-text3">Buying new home</p> */}
                    <p
                      className="mini-card-text2"
                      style={{ wordBreak: "break-word" }}
                    >
                      {message_body}
                    </p>
                  </div>
                  <button className="button-in-2">
                    Securely Send My Proof Of Funds
                  </button>
                </div>
              </div>
            </div>
            <p className="sub-text">
              This is a secure and confidential process. FastRealty only
              accesses the total amount available in your accounts, and we do
              not track or view any transactions. We will never share or sell
              your financial data.
            </p>
            <div className="buttons">
              <div className="edit-btn">
                <button
                  style={{ color: "#28A382", backgroundColor: "white" }}
                  className="button editBtn"
                  onClick={handleEditBtn}
                >
                  <img src={EditIcon} alt="edit-icon" className="edit-icon" />
                  EDIT
                </button>
              </div>

              <Button
                title="SEND"
                txtColor="white"
                bgColor="#28A382"
                disabled={showLoadingModal}
                onClickFunc={sendReport}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(ReqProofFunds);
